import { TempoLoginComponent } from './tempo-login/tempo-login.component';
//import { TokenAdmService } from '../services/token-adm.service';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { PagesComponent } from './pages.component';
import { MsalGuard, MsalService } from '@azure/msal-angular';
import { RoleGuardService } from '../services/role-guard.service';
import { NotauthorizedComponent } from './notauthorized/notauthorized.component';
import { RespuestaComponent } from './respuesta/respuesta.component';
import { HomeComponent } from './home/home.component';
import { PreguntasComponent } from './preguntas/preguntas.component';
import { TemasComponent } from './temas/temas.component';
import { BurbujaComponent } from './burbuja/burbuja.component';
import { TemaComponent } from './tema/tema.component';
import { PreguntaComponent } from './pregunta/pregunta.component';
import { VideotutorialComponent } from './videotutorial/videotutorial.component';
import { LinkComponent } from './link/link.component';
import { ResultadosBusquedaComponent } from './resultados-busqueda/resultados-busqueda.component';

const rolesEdicion = ['Help_Admin', 'Help_Contribuidor'];

let privado = null;
if (sessionStorage.getItem('privado') == 'SI') {
  privado = [MsalGuard, RoleGuardService];
} else {
  privado = null;
}

const routes: Routes = [
  {
    path: 'help',
    component: PagesComponent,
    canActivate: privado,
    children: [
      { path: '', component: HomeComponent },
      { path: 'notauthorized', component: NotauthorizedComponent },
      { path: 'respuesta/:id', component: RespuestaComponent },
      { path: 'preguntas/:temaId', component: PreguntasComponent },
      { path: 'temas/:burbujaId', component: TemasComponent },
      {
        path: 'burbuja/:burbujaId',
        component: BurbujaComponent,
        canActivate: [MsalGuard, RoleGuardService],
        data: { expectedRole: rolesEdicion },
      },
      {
        path: 'tema/:temaId',
        component: TemaComponent,
        canActivate: [MsalGuard, RoleGuardService],
        data: { expectedRole: rolesEdicion },
      },
      {
        path: 'pregunta/:preguntaId/:temaId',
        component: PreguntaComponent,
        canActivate: [MsalGuard, RoleGuardService],
        data: { expectedRole: rolesEdicion },
      },
      {
        path: 'pregunta/:preguntaId',
        component: PreguntaComponent,
        canActivate: [MsalGuard, RoleGuardService],
        data: { expectedRole: rolesEdicion },
      },
      {
        path: 'video/:videoId',
        component: VideotutorialComponent,
        canActivate: [MsalGuard, RoleGuardService],
        data: { expectedRole: rolesEdicion },
      },
      {
        path: 'link/:linkId',
        component: LinkComponent,
        canActivate: [MsalGuard, RoleGuardService],
        data: { expectedRole: rolesEdicion },
      },
      { path: 'buscar/:termino', component: ResultadosBusquedaComponent },
      {
        path: 'tempoLogin',
        component: TempoLoginComponent,
        canActivate: [MsalGuard, RoleGuardService],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
